import styled from '@emotion/styled';
import UserAvatar from '@/components/UserAvatar';

const StyledUserAvatar = styled(UserAvatar)({
  marginLeft: 15,
  marginRight: 0,
});

export default StyledUserAvatar;
